import { render, staticRenderFns } from "./navbar.vue?vue&type=template&id=79a0c72c"
import script from "./navbar.vue?vue&type=script&lang=js"
export * from "./navbar.vue?vue&type=script&lang=js"
import style0 from "./navbar.vue?vue&type=style&index=0&id=79a0c72c&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/Resourced/Resourced/Frontend-old/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('79a0c72c')) {
      api.createRecord('79a0c72c', component.options)
    } else {
      api.reload('79a0c72c', component.options)
    }
    module.hot.accept("./navbar.vue?vue&type=template&id=79a0c72c", function () {
      api.rerender('79a0c72c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/pages/frame/navbar/navbar.vue"
export default component.exports